import { Injectable } from '@angular/core';

/* 
  Processes string templates for Component Factories
*/

@Injectable({
  providedIn: 'root',
})
export class TemplateProcessor {
  tokenRegex = /\{\{(.+?)\}\}/gm;
  proccessTemplate(template: string, ctx) {
    const str = template
      .match(this.tokenRegex)
      .map(token => {
        const prop = token.replace(/(\{|\})/g, '').trim();
        return {
          token,
          prop,
        };
      })
      .reduce((acc, replacer) => {
        return acc.replace(replacer.token, ctx[replacer.prop] || '');
      }, template);
    return str;
  }
}
